import {LabUrls} from "./LabUrls";
import {CityUrls} from "./CityUrls";
import {ContactInfoUrls} from "./ContactInfoUrls";
import {ServiceDetailsUrls} from "./ServiceDetailsUrls";
import {ServicesUrls} from "./ServicesUrls";
import {UsersUrls} from "./UsersUrls";
import {ServiceCatagoriesUrls} from "./ServiceCatagoriesUrls";
import {BookingsUrls} from "./BookingsUrls";
import {PrivacyPolicyUrls} from "./PrivacyPolicyUrls";
import {TermsAndConditionsUrls} from "./TermsAndConditionsUrls";
import {PatientUrls} from "./PatientUrls";
import { BlogUrls } from "./BlogUrls";
import {LabDiagnosisUrls} from "./LabDiagnosisUrls";
import { MedicineUrls } from "./MedicineUrls";
import { MedicineDetailsUrls } from "./MedicineDetailsUrls";
import { EmployeeUrls } from "./EmployeeUrls";
import { JobUrls } from "./JobUrls";
import { JobApplicationUrls } from "./JobApplicationUrls";

export const urls = {

    ...LabUrls,
    ...BlogUrls,
    ...CityUrls,
    ...ContactInfoUrls,
    ...ServiceDetailsUrls,
    ...ServicesUrls,
    ...UsersUrls,
    ...ServiceCatagoriesUrls,
    ...BookingsUrls,
    ...PrivacyPolicyUrls,
    ...TermsAndConditionsUrls,
    ...PatientUrls,
    ...LabDiagnosisUrls,
    ...MedicineUrls,
    ...MedicineDetailsUrls,
    ...EmployeeUrls,
    ...JobUrls,
    ...JobApplicationUrls

 
};
